module.exports = __webpack_public_path__ + "static/media/home-header-back.eb737c7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home-header-back.png
// module id = 497
// module chunks = 0